import React from 'react'
import Authenticator from '../Authenticator'

interface CompProps {
  children: any
}

const AppWrapper: React.FC<CompProps> = ({ children }) => (
  <Authenticator requireAuth={false}>
    {children}
  </Authenticator>
)

export default AppWrapper
